<template>
  <div>
    <ArticleList :author="author" :items-per-page="5"></ArticleList>
  </div>
</template>

<script>
import { ArticleList } from "@/components";

export default {
  name: "ProfileArticles",
  components: {
    ArticleList
  },
  computed: {
    author() {
      return this.$route.params.username;
    }
  }
};
</script>
